import { render, staticRenderFns } from "./ImpressionsShippingSheet.vue?vue&type=template&id=5e60137e"
import script from "./ImpressionsShippingSheet.vue?vue&type=script&lang=js"
export * from "./ImpressionsShippingSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.8.1_vue-template-compiler@2.6.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports